import React, { Component } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";
import moment from "moment";
import Icon from "module-common/Icon";
import Avatar from "module-common/Avatar";
import LabelList from "module-common/label-list/LabelList";

export default class List extends Component {
  static propTypes = {
    id: PropTypes.number,
    index: PropTypes.number,
    avatar: PropTypes.string,
    name: PropTypes.string,
    lastContact: PropTypes.string,
    channel: PropTypes.string,
    labelsRaw: PropTypes.array,
    onclick: PropTypes.func
  };
  static defaultProps = {
    labels: []
  };
  state = {
    showModal: false
  };

  render() {
    const {
      id,
      index,
      avatar,
      channel,
      name,
      lastContact,
      labelsRaw,
      onClick
    } = this.props;

    // label data preparation
    const labels = [];
    for (const label of labelsRaw) {
      if (label.labelTemplate.isShown) {
        labels.push({
          label: label.labelTemplate.displayName,
          value: label.labelTemplate,
          color: "#" + label.labelTemplate.color
        });
      }
    }

    // sort labels by order and date
    labels.sort((a, b) => {
      if (a.value.order !== b.value.order) {
        return a.value.order > b.value.order;
      } else {
        return moment(a.value.dateCreated).isAfter(b.value.dateCreated);
      }
    });

    return (
      <Wrapper onClick={onClick}>
        <Index>{index}.</Index>
        <Name>
          <StyledAvatar image={avatar} isSmall />
          {name}
        </Name>
        <Contact>{lastContact}</Contact>
        <IconSocial name={channel + "-full"} width={25} height={25} />
        <Label>
          <LabelList labels={labels} />
        </Label>
      </Wrapper>
    );
  }
}

const Wrapper = styled.div`
  width: auto;
  height: auto;
  display: flex;
  flex: none;
  border-bottom: 1px solid ${props => props.theme.panelBorder};
  align-items: center;
  padding: 10px;
  &:hover {
    background: #ececec;
    font-weight: 600;
    cursor: pointer;
  }
`;

const Index = styled.div`
  margin-left: 10px;
  flex: 1;
`;

const Name = styled.div`
  flex: 4;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

const StyledAvatar = styled(Avatar)`
  margin-right: 10px;
`;

const Contact = styled.div`
  flex: 3;
`;

const IconSocial = styled(Icon)`
  flex: 2;
`;

const Label = styled.div`
  flex: 4;
  margin-right: 10px;
`;



// WEBPACK FOOTER //
// ./src/module-customer-journey/list/List.js